import { CustomMaxDirective } from './custom-max.directive';
import { CustomMinDirective } from './custom-min.directive';
import { PrintDirective } from './print.directive';
import { NoWhitespaceDirective } from './no-whitespace.directive';
import { TrimSpacesDirective } from './trim-spaces.directive';
import { PhoneInputDirective } from './phone.directive';
import { RotationAngleDirective } from './rotation-angle.directive';

export const DIRECTIVES = [
  CustomMaxDirective,
  CustomMinDirective,
  PrintDirective,
  NoWhitespaceDirective,
  TrimSpacesDirective,
  PhoneInputDirective,
  RotationAngleDirective,
];

export * from './phone.directive';
